// extracted by mini-css-extract-plugin
export var deleteIcon = "_p0-5";
export var deleteOption = "_p0-3";
export var divider = "_p0-2";
export var downloadIcon = "_p0-4";
export var drawer = "_p0-0";
export var drawerFooter = "_p0-6";
export var drawerOpen = "_p0-1";
export var highlighted = "_p0-7";
export var lighterHighlight = "_p0-8";